import { format, format_display_withtime } from "Common/Constants";
import moment from "moment"
import "moment-timezone";

export const formatDate = (date = undefined, format = format_display_withtime) => {
    if (!date) return ""
    return moment(date).format(format)
}


export const formatDateToIST = (date = undefined, format = format_display_withtime) => {
    if (!date) return ""
    const timeInUTC = moment.utc(date)
    return timeInUTC.clone().tz("Asia/Kolkata").format(format)
}

export const currentDateTimeString = (dateFormat = format) => {
    return moment().format(dateFormat)
}

export const dateToIST = (date = undefined) => {
    if (!date) return ""
    const timeInUTC = moment.utc(date)
    return timeInUTC.clone().tz("Asia/Kolkata")
}

export const daysFromNow = (date) => {
    if (!date) return undefined
    const dateObj = new Date(Date.parse(date.substring(0, 10)))
    return moment(dateObj).diff(moment(), 'd')
}

export const getTimeZone = () => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    return timeZone
}

export const formatDateToTimeZone = (date = undefined, timezone = "Asia/Kolkata", format = format_display_withtime) => {
    if (!date) return ""
    const timeInUTC = moment.utc(date)
    return timeInUTC.clone().tz(timezone).format(format)
}

export const dateToTimeZone = (date = undefined, timezone = "Asia/Kolkata") => {
    if (!date) return ""
    const timeInUTC = moment.utc(date)
    return timeInUTC.clone().tz(timezone)
}